import Features from "../../components/Features/Features";
import plumber from "../../images/images.jpg";
import { Link } from "react-router-dom";
function Services() {
  return (
    <>
      <section className="services-presentation">
        <h1>Nos Expert Pour une installation efficace.</h1>
        <p>
          Chez Lemaire Plomberie des Weppes, Nous vous conseillons le meilleur en matière de plomberie chauffage, poêle, tubage, ramonage,
          cuisine et salle de bain afin que vos attente soit satisfait. Que ce soit pour une simple réparation ou une installation complexe
          nos experts trouveront la solution. N'hésitez pas à nous contacter pour une installation efficace.
        </p>
      </section>
      <section>
        <div className="solution-container">
          <article className="solution-text">
            <h1>Nos Services</h1>
            <div className="solution-feature service-feature">
              <Features title={"Réponse Rapide"} text={"Nous vous offrons une réponse rapide pour des réparations urgentes."} />
              <Features
                title={"Solutions Fiables"}
                text={"Nous vous offrons une solution fiable en cas de fuite ou de problème avec votre chauffage"}
              />
              <Features
                title={"Installation Efficace"}
                text={
                  "Nos experts vous accompagnent tout au long du processus, nous assurons que chaque élément est parfaitement installé."
                }
              />
              <Features
                title={"Entretien"}
                text={
                  "Notre service de ramonage est effectué par des professionnels qualifiés, qui veillent à ce que votre conduit soit parfaitement nettoyé."
                }
              />
            </div>
          </article>
          <section>
            <img className="plumber-image" src={plumber} alt="plumber" />
          </section>
        </div>
      </section>
      <section className="get-in-touch">
        <h1>Prenez Contact</h1>
        <p>Contactez nous afin de convenir d'un rendez-vous.</p>
        <div className="button-group">
          <Link to={"/contact"} className="button">
            Contact
          </Link>
          <Link to={" FAQ"} className="button-two">
            FAQ
          </Link>
        </div>
      </section>
    </>
  );
}

export default Services;
